<template>
  <div class="row">
    <div
      class="col-3 print-hidden mb-10"
      :class="invoice.cancelledAt || invoice.paidAt ? 'col-3' : 'col-sm-6'"
    >
      <span
        class="bg-danger text-white d-inline-block invoice__badge"
        v-if="invoice.cancelledAt"
      >
        Cancelled
      </span>
      <span
        class="bg-success text-white d-inline-block invoice__badge"
        v-else-if="invoice.paidAt"
      >
        &#10003; Paid {{ paymentMethod }}
      </span>
      <span class="bg-warning text-white d-inline-block invoice__badge" v-else>
        Unpaid
      </span>
    </div>
    <div
      class="invoice__controls-wrapper print-hidden"
      :class="invoice.cancelledAt || invoice.paidAt ? 'col-9' : 'col-sm-6'"
    >
      <ActionButton
        label=""
        class="invoice__controls w-auto d-inline-block mt-0"
        @customEvent="handlePrintClick"
        :theme="{ primary, secondary, event, danger }"
      >
        <i class="fa fa-print mr-5"></i>
        <span>Print</span>
      </ActionButton>
      <ActionButton
        label=""
        :theme="{ primary, secondary, event, danger }"
        v-if="!invoice.cancelledAt && !invoice.paidAt"
        class="ml-10 btn--paypal invoice__controls w-auto d-inline-block mt-0"
        @customEvent="handlePayment"
        :disabled="invoice.paidAt"
      >
        <i class="fa fa-paypal mr-5"></i>
        <span>Payment</span>
      </ActionButton>
    </div>
    <InvoicePayment
      v-if="showModal && !invoice.cancelledAt && !invoice.paidAt"
      @close="handleClose"
      @reinit="handleReinit"
      :invoice="invoice"
      scope="user"
    />
  </div>
</template>

<script>
import InvoicePayment from "@/components/invoice/InvoicePayment";
import ActionButton from "@/components/ActionButton";
import axios from "@/helpers/axios";
import _ from "lodash";
import { dateToday } from "@/helpers/date";
import * as logger from "@/helpers/logger";

export default {
  props: {
    invoice: {
      type: [Object],
      default: null
    }
  },
  components: {
    ActionButton,
    InvoicePayment
  },
  data() {
    return {
      showModal: false
    };
  },
  created() {
    this.handlePayment();
  },
  computed: {
    paymentMethod() {
      const paymentMethod = _.find(this.invoice.OrderMeta, {
        key: "paymentMethod"
      });
      if (paymentMethod) {
        return " via " + paymentMethod.value;
      }
      return "";
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    handlePrintClick() {
      try {
        document.execCommand("print", false, null);
      } catch (error) {
        window.print();
      }
    },
    handlePayment() {
      this.handlePaymentAsync();
    },
    async handlePaymentAsync() {
      const invoice = JSON.parse(JSON.stringify(this.invoice));
      if (invoice) {
        const orders = this.invoice.OrderPackages;
        var isavailable = true;
        for (var order of orders) {
          const id = order.Package.productId;
          await axios
            .get(
              `/products/${id}/availability?qp[start]=${order.startAt}&qp[end]=${order.endAt}&qp[op]=${order.id}`
            )
            .then(response => {
              const available = response.data.available;
              if (available === false) {
                isavailable = false;
              }
            });
        }
        if (isavailable) {
          this.showModal = true;
        } else if (!this.invoice.cancelledAt) {
          this.$swal(
            "Warning",
            "Overlapped bookings, please create another order",
            "warning"
          );
        }
      }
    },
    handlePaymentMethod() {
      return null;
    },
    handleReinit() {
      this.$emit("reinit");
    },
    handleClose() {
      this.showModal = false;
    },
    handleCancelInvoice(id, code) {
      this.$swal({
        title: "Are you sure you want to cancel this order?",
        text: code,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#e15a4e",
        cancelButtonText: "No",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          axios
            .patch("/orders/" + id, {
              cancelledAt: dateToday()
            })
            .then(response => {
              logger.log(response);
              this.$emit("reinit");
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.invoice {
  &__badge {
    min-width: 100px;
    border-radius: 5px;
    padding: 8px 14px;
    font-size: $font-size-base;
    text-align: center;
  }
  &__modal {
    background: black;
  }
}
.invoice {
  @media print {
    margin-top: 0;
    position: absolute;
    top: 0;
  }
  &__controls-wrapper {
    text-align: right;
    @media (max-width: 575px) {
      &.col-sm-6 {
        text-align: left;
      }
    }
  }
  &__controls {
    padding: 8px 14px;
    span {
      line-height: 24px;
    }
  }
}
</style>
